import { Component, OnInit, Input, ElementRef, ChangeDetectorRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NpFlexGridCtrl } from '../np-flex-grid-ctrl';

import { CellRange, FlexGrid } from '@grapecity/wijmo.grid';
import { CommonModule } from '@angular/common';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
@Component({
  selector: 'np-flex-grid-menu',
  templateUrl: './np-flex-grid-menu.component.html',
  styleUrls: ['./np-flex-grid-menu.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, WjInputModule]
})
export class NpFlexGridMenuComponent implements OnInit {

  mode: 'menu-mode' | 'column-picker' = 'menu-mode';

  initialized: boolean = false;

  @Input('show') show: boolean = false;
  @Input('flexGridCtrl') flexGridCtrl!: NpFlexGridCtrl;

  public get flexGrid(): FlexGrid | undefined {
    if (this.flexGridCtrl?.flexGrid) {
      return this.flexGridCtrl?.flexGrid;
    } else {
      return undefined
    }
  }

  allChkFlag = false;
  location_pathname = window.location.pathname;

  el: ElementRef;
  nativeElement: HTMLElement;
  // columns : any;
  // @HostListener('blur') onmouseleave(e?: EventArgs) {

  //   console.log(this.nativeElement.focus);
  //   this.nativeElement.onblur
  //   // console.log('onmouseleave', e);
  //   // this.nativeElement.remove();
  // }
  // @HostListener('mouseout') onmouseout(e?: EventArgs) {
  //   console.log('onmouseout', e);
  // }
  constructor(el: ElementRef, private cdr: ChangeDetectorRef) {
    this.el = el;
    this.nativeElement = el.nativeElement;
  }

  ngOnInit() {
    // this.initCustomColumns();
    this.initialized = true;
  }

  toggle($event?: Event) {
    if (this.show) {
      this.close();
    } else {
      this.show = true;
    }

    if ($event) {
      // $event.stopPropagation();
      $event.preventDefault();
    }
  }

  close() {
    this.show = false;
    this.mode = 'menu-mode';
  }

  initCustomColumns() {
    try {
      setTimeout(() => {
        const saveColumn = localStorage.getItem(this.location_pathname + '-column-save');
        if (saveColumn) {
          this.mode = 'column-picker';
          this.toggle();
          setTimeout(() => {
            setTimeout(() => {
              this.close();
            }, 50);
          }, 50);
        }
      }, 30);
    } catch (e) {
      console.log(e);
    }
  }

  showColumnPicker() {
    this.mode = 'column-picker';
  }

  selectAll() {
    if (!this.flexGrid) {
      return;
    }

    this.flexGrid.select(new CellRange(0, 0, this.flexGrid.rows.length - 1, this.flexGrid.columns.length - 1));
    this.show = false;
  }

  autoSizeColumns() {
    if (!this.flexGrid) {
      return;
    }

    this.flexGrid.autoSizeColumns();
    this.close();
  }

  showFreezBar() {
    if (!this.flexGridCtrl.freezBar) {
      return;
    }
    this.flexGridCtrl.freezBar.show();
    this.close();
  }

  hideFreezBar() {
    if (!this.flexGridCtrl.freezBar) {
      return;
    }

    this.flexGridCtrl.freezBar.hide();
    this.close();
  }

  public get canExcelDownload() {
    return this.flexGridCtrl.canExcelDownload;
  }

  saveToExcel() {
    this.flexGridCtrl.saveToExcel();
    this.close();
  }

  saveFlexGridLayout() {
    this.flexGridCtrl.saveUserStateConfig();
    this.close();
  }

  clearFlexGridLayout() {
    this.flexGridCtrl.deleteUserStateConfig();
    this.close();
  }

  // @ViewChild('columnsList', { static: false }) columnsList: any;
  // toggleAllColumns() {
  //   const columns = this.flexGridCtrl.flexGrid.columns;
  //   var hasInvisible = columns.some(c => c.visible !== true);
  //   columns.forEach(c => c.visible = hasInvisible);
  //   // 갱신을 하지 않음.
  //   // this.columnsList.refresh();
  // }

}
